import React from "react";
import Spinner from 'react-bootstrap/Spinner';
import './PhotoGrid.css';

const resizeUrl = (url, width) => {
    return url.replace(/common-vehicle-media\//img, "resize/100x0/common-vehicle-media/");
};

function PhotoGrid(props) {
    if (props.cvm) {
        let basePhotos = props.cvm.baseMerchandisingPhotos
            ? props.cvm.baseMerchandisingPhotos.photos.map(p => <img key={p.mediaAssetId} src={resizeUrl(p.publicUrl)} alt={p.mediaAssetId} />)
            : [];
        let merchPhotos = props.cvm.merchandisedPhotos
            ? props.cvm.merchandisedPhotos.photos.map(p => <img key={p.mediaAssetId} src={resizeUrl(p.publicUrl)} alt={p.mediaAssetId} />)
            : [];
        let profiles = props.cvm.merchandisedProfiles ? Object.fromEntries(props.cvm.merchandisedProfiles.map(profile => [
            profile.profileName,
            profile.photos.map(p => <img key={p.mediaAssetId} src={resizeUrl(p.publicUrl)} alt={p.mediaAssetId} />)
        ])) : [];
        let sources = props.cvm.sourcePhotoSets ? Object.fromEntries(props.cvm.sourcePhotoSets.map(profile => [
            profile.sourceName,
            profile.photos.map(p => <img key={p.mediaAssetId} src={resizeUrl(p.publicUrl)} alt={p.mediaAssetId} />)
        ])) : [];

        return <div>
            <div className="photo-grid">
                <h3>Base Photos</h3>
                {basePhotos}
            </div>
            <hr/>
            <div className="photo-grid">
                <h3>Merchandised Photos</h3>
                {merchPhotos}
            </div>
            <hr/>
            <h3>Merchandised Profiles</h3>
            <div className="profiles">
            {Object.entries(profiles).map(([profileName, photos]) => <div key={profileName} className="photo-grid">
                <h4><b>Profile Name:</b> {profileName}</h4>
                {photos}
            </div>)}
            </div>
            <hr/>
            <h3>Source Sets</h3>
            <div className="sources">
            {Object.entries(sources).map(([sourceName, photos]) => <div key={sourceName} className="photo-grid">
                <h4><b>Source Name:</b> {sourceName}</h4>
                {photos}
            </div>)}
            </div>       
        </div>;
    }
    return <Spinner animation="border" />;
}

export default PhotoGrid;